export default "<p>\n  Marino Moretti (1885 – 1979) è stato un poeta, romanziere e drammaturgo\n  italiano, noto soprattutto come poeta crepuscolare.\n</p>\n";